/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var VsdIcon = createIcon("VsdIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#185ABD';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.921 30 4.563-13.014H15.36L11.652 27.48 7.944 16.986H5.829L10.383 30h2.538Zm10.863.18c3.114 0 5.085-1.593 5.085-3.636 0-1.377-.45-3.267-3.357-3.861l-2.34-.522c-1.53-.351-1.989-.837-1.989-1.683 0-1.17 1.134-1.872 2.565-1.872 1.44 0 2.592.54 2.754 2.088h2.214c-.027-2.106-1.746-3.87-4.995-3.87-2.781 0-4.86 1.539-4.842 3.897.027 1.899 1.215 3.033 3.159 3.429l2.394.522c1.332.288 2.223.819 2.223 1.89 0 1.206-1.269 1.863-2.88 1.863-1.521 0-2.727-.711-3.015-2.025h-2.268c.297 2.511 2.763 3.78 5.292 3.78ZM34.746 30c4.698 0 6.885-2.412 6.885-6.579 0-3.996-1.998-6.327-6.75-6.417-.298-.005-.67-.008-1.06-.01l-.592-.004-.576-.002-1.205-.002h-.068V30h3.366Zm.036-1.809h-1.179v-9.396h1.233c2.808 0 4.5 1.26 4.5 4.635 0 3.492-1.881 4.761-4.554 4.761Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.VsdIcon",
  "replaceColor": true
});